import { Button } from 'components/Button';
import ModalContainer from 'components/Modal/ModalContainer';
import styled from 'styled-components';

const ButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    gap: 12px;
    font-size: 14px;
`;

const CancelButton = styled(Button)`
    background-color: #efefef;
    color: ${({ theme }) => theme.gray_2};
    border: none;
    &:hover {
        background-color: ${({ theme }) => theme.gray_5};
    }
`;

const DeleteButton = styled(Button)`
    background: #e64942;
    color: white;
    border: none;
    &:hover {
        background: #cc3e38;
    }
`;

const ConfirmDeleteModal = ({
    isOpen,
    onCancel,
    onConfirm,
    title,
    text = 'Are you sure you want to delete this item?',
}) => {
    if (!isOpen) return null;

    return (
        <ModalContainer isOpen={isOpen} onClose={onCancel} title={title}>
            <div>
                {text}
                <ButtonRow>
                    <CancelButton intent="secondary" onClick={onCancel}>
                        Cancel
                    </CancelButton>
                    <DeleteButton intent="secondary" onClick={onConfirm}>
                        Delete
                    </DeleteButton>
                </ButtonRow>
            </div>
        </ModalContainer>
    );
};

export default ConfirmDeleteModal;
